import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export const MAX_RANGE_MS = 2 * 24 * 60 * 60 * 1000

export function isValidRange(from, to) {
    return from?.isValid?.() && to?.isValid?.() && !to.isBefore(from)
}

export function clampOnFromChange(newFrom, to) {
    if (!newFrom?.isValid?.()) return to
    if (!to?.isValid?.() || to.isBefore(newFrom)) return newFrom
    const maxTo = newFrom.add(MAX_RANGE_MS, "millisecond")
    if (to.isAfter(maxTo)) return maxTo
    return to
}

export function clampOnToChange(from, newTo) {
    if (!newTo?.isValid?.()) return from
    if (!from?.isValid?.() || newTo.isBefore(from)) return newTo
    const minFrom = newTo.subtract(MAX_RANGE_MS, "millisecond")
    if (from.isBefore(minFrom)) return minFrom
    return from
}

export function defaultFrom() {
    return dayjs.utc().startOf("day")
}

export function defaultTo() {
    return dayjs.utc()
}
